import React from "react";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { TextField } from "Components/Base/Inputs/TextField";
import { Box } from "Components/Base/Layout/Box";
import { METADATA_FIELD_TYPE } from "lib/components/ItemMetadataFields/itemMetadata.constants";
import {
  MetadataRequiredMark,
  metadataFieldErrorFormHelperTextProps,
} from "lib/components/ItemMetadataFields/fields/shared";

const TextLikeField = ({ field, fieldState, disabled, onChange }) => {
  const { fieldError, fieldId, labelText, required, value } = fieldState;
  const invalidText =
    Boolean(fieldError) || (required && !String(value).trim());

  return (
    <Box mb={1.25}>
      <Typography component="label" htmlFor={fieldId} variant="body1">
        {labelText}
        {required ? <MetadataRequiredMark /> : null}
      </Typography>
      <TextField
        id={fieldId}
        fullWidth
        disabled={disabled}
        value={value}
        error={Boolean(fieldError)}
        helperText={fieldError}
        FormHelperTextProps={metadataFieldErrorFormHelperTextProps}
        onChange={(event) => onChange(field.id, event.target.value)}
        inputProps={{
          maxLength: field.fieldType === METADATA_FIELD_TYPE.Numeric ? 12 : 255,
          "aria-required": required ? "true" : "false",
          "aria-invalid": invalidText ? "true" : "false",
        }}
      />
    </Box>
  );
};

export default TextLikeField;
